import posthog from 'posthog-js'

let initialized = false

export type ConsentChoice = {
  analytics: boolean
}

export const DEFAULT_CONSENT: ConsentChoice = {
  analytics: false,
}

export function initPostHog(apiKey: string, apiHost: string) {
  if (initialized || typeof window === 'undefined') return
  posthog.init(apiKey, {
    api_host: apiHost,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    opt_out_capturing_by_default: true,
    persistence: 'memory',
    respect_dnt: true,
  })
  initialized = true
}

export function applyConsent(choice: ConsentChoice) {
  if (!initialized) return
  if (choice.analytics) {
    posthog.opt_in_capturing()
    posthog.set_config({
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      persistence: 'localStorage+cookie',
    })
  } else {
    posthog.opt_out_capturing()
    posthog.set_config({ persistence: 'memory' })
  }
}

export { posthog }
